import { ErrorSchema } from '@diamond/shared/schema';
import { SessionRecoveryError } from '@diamond/shared/utils';
import { Value } from '@sinclair/typebox/value';
import axios from 'axios';

export function getCartFailure(error: unknown) {
  if (error instanceof SessionRecoveryError) {
    return { message: error.message, dailyLimit: false };
  }
  if (!axios.isAxiosError<unknown>(error)) {
    return { message: 'Gagal menambah ke keranjang', dailyLimit: false };
  }
  const status = error.response?.status;
  if (status === 401) {
    return {
      message: 'Sesi Anda telah berakhir. Silakan masuk kembali.',
      dailyLimit: false,
    };
  }
  if (status === 403) {
    return {
      message: 'Anda tidak memiliki akses untuk menambah produk ke keranjang.',
      dailyLimit: false,
    };
  }
  const data = error.response?.data;
  if (
    Value.Check(ErrorSchema, data) &&
    [
      'DAILY_ORDER_LIMIT_EXCEEDED',
      'INSUFFICIENT_STOCK',
      'MIN_ORDER_QUANTITY_NOT_REACHED',
    ].includes(data.error)
  ) {
    return {
      message: data.message,
      dailyLimit: data.error === 'DAILY_ORDER_LIMIT_EXCEEDED',
    };
  }
  return {
    message: 'Gagal menambah ke keranjang. Silakan coba lagi.',
    dailyLimit: false,
  };
}
